/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statsexplainactive2Inputs */

const en_statsexplainactive2 = /** @type {(inputs: Statsexplainactive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accounts per day that sent a message or answered a plan.`)
};

const de_statsexplainactive2 = /** @type {(inputs: Statsexplainactive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konten pro Tag, die eine Nachricht geschrieben oder auf einen Plan geantwortet haben.`)
};

/**
* | output |
* | --- |
* | "Accounts per day that sent a message or answered a plan." |
*
* @param {Statsexplainactive2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statsexplainactive2 = /** @type {((inputs?: Statsexplainactive2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statsexplainactive2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statsexplainactive2(inputs)
	return de_statsexplainactive2(inputs)
});
export { statsexplainactive2 as "statsExplainActive" }